import React from 'react';

const shimmer = 'animate-pulse bg-gray-200/60 rounded';

export function SkeletonLoader({ variant = 'card', rows = 5 }) {
  if (variant === 'hero') {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="glass-card rounded-2xl p-4 lg:p-5">
            <div className={`h-3 w-16 mb-3 ${shimmer}`} />
            <div className={`h-6 w-20 mb-2 ${shimmer}`} />
            <div className={`h-4 w-14 ${shimmer}`} />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'chart') {
    return (
      <div className="glass-card rounded-2xl p-6">
        <div className={`h-4 w-32 mb-4 ${shimmer}`} />
        <div className={`h-64 w-full ${shimmer}`} />
      </div>
    );
  }

  if (variant === 'table') {
    return (
      <div className="glass-card rounded-2xl p-6">
        <div className={`h-4 w-40 mb-4 ${shimmer}`} />
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className={`h-10 w-full mb-2 ${shimmer}`} />
        ))}
      </div>
    );
  }

  if (variant === 'strip') {
    return <div className={`h-12 w-full rounded-2xl ${shimmer}`} />;
  }

  if (variant === 'text') {
    return (
      <div className="space-y-2">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className={`h-4 ${i === rows - 1 ? 'w-2/3' : 'w-full'} ${shimmer}`} />
        ))}
      </div>
    );
  }

  // Default card
  return (
    <div className="glass-card rounded-2xl p-4 lg:p-5">
      <div className={`h-3 w-16 mb-3 ${shimmer}`} />
      <div className={`h-6 w-20 mb-2 ${shimmer}`} />
      <div className={`h-4 w-14 ${shimmer}`} />
    </div>
  );
}
